import { getCurrentScript } from '@kurtosys/app-loader/dist/script.js';
import { common } from '@kurtosys/ksys-app-template';
import { IManifest } from '@kurtosys/types/appsManager/IManifest.js';

export function getApplicationCode(manifest: IManifest) {
	if (manifest.isDevelopment) {
		return manifest.testGuid;
	}
	const currentScript = getCurrentScript(manifest);
	if (currentScript) {
		const { src } = currentScript as any;
		const regex = /\/apps\/(.*)\/main-ksys-(.*)\.js/;
		const match = regex.exec(src);
		if (match && match.length > 1) {
			const [, applicationCode] = match;
			return applicationCode;
		}
	}
	return;
}

export function getStoreKey(element: HTMLElement, url: string, manifest: IManifest) {
	// Refactor to allow for static retrieval of the appParams
	const helper = new common.helpers.AppParamsHelper(element, url);
	const appParams = helper.getAppParamsFromElement();
	if (appParams.storeKey) {
		return appParams.storeKey;
	}
	// Check if there is an explicit key that is supposed to be used for the store
	// that is defined on the element
	const { configurationKey = 'default', styleKey = 'default', applicationCode = '' } = appParams;

	const keys = [manifest.storeKey, configurationKey, styleKey];

	if (applicationCode.length > 0) {
		keys.push(applicationCode);
	}

	const { inputs = {} }: Record<string, any> = helper;
	const inputKeys = Object.keys(inputs).sort();
	const inputText = `(inputs=${inputKeys.map((key) => `${key}:${inputs[key]}`).join(',')})`;
	keys.push(inputText);
	return keys.join('-');
}
